import styled, { css } from 'styled-components';
import { HEX } from '../Styles/LegacyColors/index.js';
import { commonResets } from '../Styles/Utils/commonResets.js';
import { phone, tabletMax, phoneMax } from '../Styles/MediaQueries/mediaQueries.js';

// TO DO: Extract styles from _commonStyles to packages/styles (WP-255)
const gradient = css`
    @supports (-webkit-background-clip: text) {
        background: linear-gradient(to top right, #ff0045, #3b00ff);
        /* stylelint-disable-next-line property-no-vendor-prefix */
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        display: inline-block;
    }
`;
const textCommon = css`
    color: ${HEX.darkGrey};
    letter-spacing: 0;
    margin-bottom: 15px;
`;
const StyledTextComponent = styled.div.attrs(({ styleModifiers ={} , className , styleMixin  })=>{
    const modifiers = Object.keys(styleModifiers).reduce((prev, curr)=>{
        return styleModifiers[curr] ? [
            ...prev,
            curr
        ] : [
            ...prev
        ];
    }, []);
    const mergedClassName = [
        className,
        styleMixin,
        ...modifiers
    ].filter((val)=>val !== undefined).join(" ");
    return {
        className: mergedClassName
    };
}).withConfig({
    displayName: "Typography.styles__StyledTextComponent",
    componentId: "sc-cdcd838c-0"
})`
    ${commonResets}
    & *,
    &:before,
    & :before,
    &:after,
    & :after {
        ${commonResets}
    }

    & [data-gradient='true'],
    & * [data-gradient='true'] {
        ${gradient}
    }

    &.mini {
        color: ${HEX.darkGrey};
        letter-spacing: 0;
        margin-bottom: 15px;

        font-size: 12px;
        line-height: 1.45;
        font-weight: 300;
    }

    &.small {
        color: ${HEX.darkGrey};
        letter-spacing: 0;
        margin-bottom: 15px;

        font-size: 16px;
        line-height: 1.45;
        font-weight: 300;
    }

    ${(props)=>{
    switch(props.tag){
        case "h1":
            return css`
                    ${textCommon}

                    font-size: 71px;
                    font-weight: 300;
                    line-height: 1.25;

                    &.uppercase {
                        text-transform: uppercase;
                    }

                    &.gradient {
                        ${gradient}
                    }

                    @media ${phone} and ${tabletMax} {
                        font-size: 48px;
                    }
                `;
        case "h2":
            return css`
                    ${textCommon}

                    font-size: 56px;
                    font-weight: 300;
                    line-height: 1.25;

                    &.uppercase {
                        text-transform: uppercase;
                    }

                    &.lined {
                        position: relative;
                        padding-bottom: 49px;

                        &:after {
                            content: ' ';
                            display: block;
                            width: 60px;
                            height: 4px;
                            background: ${HEX.blue};
                            position: absolute;
                            bottom: 0;
                            left: 0;
                        }
                    }

                    &.gradient {
                        ${gradient}
                    }

                    @media ${phone} and ${tabletMax} {
                        font-size: 40px;
                    }
                `;
        case "h3":
            return css`
                    ${textCommon}

                    font-size: 36px;
                    font-weight: 300;
                    line-height: 1.25;

                    &.uppercase {
                        text-transform: uppercase;
                    }

                    &.lined {
                        position: relative;
                        padding-bottom: 19px;

                        &:after {
                            content: ' ';
                            display: block;
                            width: 60px;
                            height: 4px;
                            background: ${HEX.blue};
                            position: absolute;
                            bottom: 0;
                            left: 0;
                        }
                    }

                    &.centred {
                        width: 100%;
                        text-align: center;

                        &:after {
                            left: 50%;
                            margin-left: -30px;
                        }
                    }

                    &.gradient {
                        ${gradient}
                    }

                    @media ${phone} and ${tabletMax} {
                        font-size: 25px;
                    }

                    @media ${phone} and ${phoneMax} {
                        font-size: 20px;
                    }
                `;
        case "h4":
            return css`
                    ${textCommon}

                    font-size: 25px;
                    font-weight: 300;
                    line-height: 1.35;

                    &.uppercase {
                        text-transform: uppercase;
                    }

                    &.lined {
                        position: relative;
                        padding-bottom: 19px;

                        &:after {
                            content: ' ';
                            display: block;
                            width: 60px;
                            height: 4px;
                            background: ${HEX.darkGrey};
                            position: absolute;
                            bottom: 0;
                            left: 0;
                        }
                    }

                    &.centred {
                        width: 100%;
                        text-align: center;

                        &:after {
                            left: 50%;
                            margin-left: -30px;
                        }
                    }

                    &.gradient {
                        ${gradient}
                    }

                    @media ${phone} and ${tabletMax} {
                        font-size: 20px;
                    }
                `;
        case "p":
            return css`
                    ${textCommon}

                    font-size: 24px;
                    line-height: 1.45;
                    font-weight: 300;

                    &.large {
                        font-size: 49px;
                        line-height: 1.25;

                        @media ${phone} and ${tabletMax} {
                            font-size: 24px;
                            line-height: 1.45;
                        }

                        @media ${phone} and ${phoneMax} {
                            font-size: 16px;
                        }
                    }

                    &.small {
                        font-size: 16px;

                        @media ${phone} and ${tabletMax} {
                            font-size: 20px;
                        }

                        @media ${phone} and ${phoneMax} {
                            font-size: 16px;
                        }
                    }

                    &.mini {
                        font-size: 12px;

                        @media ${phone} and ${tabletMax} {
                            font-size: 20px;
                        }

                        @media ${phone} and ${phoneMax} {
                            font-size: 16px;
                        }
                    }

                    &.gradient {
                        ${gradient}
                    }

                    @media ${phone} and ${tabletMax} {
                        font-size: 20px;
                    }

                    @media ${phone} and ${phoneMax} {
                        font-size: 16px;
                    }
                `;
        default:
            return "";
    }
}}
`;

export { StyledTextComponent };
